<i18n>
{
"en": {
  "VIOLATIONTYPE": "Violation Type",
  "VIOLATIONS": "Violations",
  "CHOOSEFILTERBY": "Choose Filter By",
  "FILTERBYBUS": "Filter by bus",
  "FILTERBYTYPE": "Filter by type",
  "PICKARANGE": "Pick a range",
  "LOADING": "Loading...",
  "ROUTE": "Route",
  "DRIVER": "Driver",
  "BUS": "Bus",
  "VIOLATION": "Violation",
  "STICK": "Stick",
  "UNSTICK": "Unstick",
  "SHOW": "Show",
  "HIDE": "Hide",
  "DATE": "Date",
  "SMOKEDETECTED": "Smoke detected",
  "PANICBUTTONPRESSED": "Panic button pressed",
  "HIGHSPEEDALARM": "High speed alarm",
  "violation_video_loss": "Lost video signal",
  "violation_motion_detection": "Motion detected",
  "violation_blind": "Camera {pos} is blind",
  "violation_storage": "Storage error @3 on disk @1",
  "violation_user_1": "Smoke detected",  
  "violation_user_2": "Airflow-Sensor",
  "violation_user_3": "Inner Temperature",
  "violation_user_4": "Inner Humidity",
  "violation_user_5": "Bus stalled",
  "violation_user_6": "User alarm 6",
  "violation_user_7": "User alarm 7",
  "violation_user_8": "User alarm 8",
  "violation_user_9": "User alarm 9",
  "violation_user_10": "User alarm 10",
  "violation_emergency": "Panic button pressed",
  "violation_low_speed": "Low speed alarm (@1 km/h)",
  "violation_high_speed": "High speed alarm (@1 km/h)",
  "violation_low_voltage": "Low voltage (@1 v)",
  "violation_acceleration": "Acceleration alarm @1",
  "violation_header": "Service Level Agreement Violations and Alarms"
},
"ar": {
  "VIOLATIONTYPE": "نوع الانتهاك",
  "VIOLATIONS": "الانتهاكات",
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "FILTERBYBUS": "تصفية حسب الحافلة",
  "FILTERBYTYPE": "تصفية حسب النوع",
  "PICKARANGE": " اختيار مجموعة",
"LOADING": "جار التحميل...",
  "ROUTE": "طريق",
  "DRIVER": "سائق",
  "BUS": "حافلة",
  "VIOLATION": "انتهاك",
  "STICK": "لصق",
  "UNSTICK": "فك",
  "SHOW": "عرض",
  "HIDE": "إخفاء",
  "DATE": "تاريخ",
  "SMOKEDETECTED": "تم الكشف عن الدخان",
  "PANICBUTTONPRESSED": "تم الضغط على زر الهلع",
  "HIGHSPEEDALARM": "تنبيه السرعة العالية",
   "VIEWINCIDENTDETAILS": "عرض تفاصيل الحادث",
   "WRITEAMESSAGE": "اكتب رسالة",
  "violation_video_loss": "فقدت إشارة الفيديو",
  "violation_motion_detection": "تم اكتشاف حركة",
  "violation_blind": "عمياء {POS } الكاميرا",
  "violation_storage": "خطأ في التخزين @ 3 على القرص @ 1",
  "violation_user_1": "تم الكشف عن الدخان",  
  "violation_user_2": "  استشعار تدفق الهواء ",
  "violation_user_3": "درجة الحرارة الداخلية",
  "violation_user_4": "الرطوبة الداخلية",
  "violation_user_5": "توقفت الحافلة ",
  "violation_user_6": " 6 تنبيه المستخدم ",
  "violation_user_7": "7 تنبيه المستخدم",
  "violation_user_8": "8 تنبيه المستخدم",
  "violation_user_9": " 9 تنبيه المستخدم",
  "violation_user_10": " 10 تنبيه المستخدم",
  "violation_emergency": "تم الضغط على زر الهلع",
  "violation_low_speed": "( إنذار انخفاض السرعة ( @ 1 كم / ساعة",
  "violation_high_speed": "(@ 1 كم / ساعة) إنذار ارتفاع السرعة ",
  "violation_low_voltage": "( V انخفاض الجهد (@ 1",
  "violation_acceleration": "1 @ تنبيه السرعة",
  "violation_header": "اتفاقية مستوى الخدمة الانتهاكات والإنذارات"  
}
}
</i18n>
<template>
  <div id="incident">
    <el-card  class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;" class="title">{{$t('VIOLATIONS')}}</span>

      </div>
      <div class="filters" ref="filter">   
        <el-row :gutter="20">
          <el-col :span="4">
            <el-select   @change="changedFilter"  v-model="filter" :placeholder="$t('CHOOSEFILTERBY')">
              <el-option
                v-if="item.value!=active_filter"
                :key="index" v-for="(item, index) in options"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>         
           </el-col>
         <el-col :span="4"  v-if="active_filter=='bus'">
             <el-select  v-model="BusID" :placeholder="$t('FILTERBYBUS')" clearable  @change="getViolations(true)">
              <el-option
                :key="index" v-for="(item, index) in buses"
                :label="item.Label"
                :value="item.BusID">
              </el-option>
            </el-select>    
           </el-col>

         <el-col :span="4"  v-if="active_filter=='type'">
             <el-select  v-model="Label" :placeholder="$t('FILTERBYTYPE')" clearable  @change="getViolations(true)">
              <el-option
                :key="key"
                v-for="(item, key) in violationTypes"
                :label="item"
                :value="key">
              </el-option>
            </el-select>      
           </el-col>
          <el-col :span="4"  v-if="active_filter=='date'">
              <el-date-picker
                v-model="date"
                type="daterange"
                @change="getViolations(true)"
                :placeholder="$t('PICKARANGE')">
              </el-date-picker>     
           </el-col>
          </el-row>
      </div>
      <el-table
         v-loading="new_page || loading"    
         :element-loading-text="$t('LOADING')"
        :data="violations[currentPage - 1]"
        :height="tableHeight"
        stripe
        style="width: 100%">
        <el-table-column
          :label="$t('ROUTE')">
          <template slot-scope="scope">
            {{scope.row.TourName}}<br/><small>{{scope.row.datetime}}</small>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('DRIVER')">
          <template slot-scope="scope">
            {{_FullName({NameEN: scope.row.DriverName_EN, NameAR: scope.row.DriverName_AR})}}            
          </template>
        </el-table-column>
        <el-table-column
          prop="bus_plate"
          :label="$t('BUS')">
        </el-table-column>
        <el-table-column
          :label="$t('VIOLATION')">
          <template slot-scope="scope">
            {{$t(scope.row.Label)}}
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template slot-scope="scope">
            <el-tooltip v-if="isAllowed('flag', 'report/violation')" :content="scope.row.IsSticky ? $t('UNSTICK') : $t('STICK')" placement="top">
              <el-button type="text" @click="flagItem(scope.row, 'sticky')"><i class="fa" :class="[scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']" ></i></el-button>
            </el-tooltip>
            <el-tooltip v-if="isAllowed('flag', 'report/violation')" :content="scope.row.IsHidden ? $t('SHOW') : $t('HIDE')" placement="top">
              <el-button type="text" @click="flagItem(scope.row, 'hidden')"><i class="fa" :class="[scope.row.IsHidden ? 'fa-eye-slash' : 'fa-eye']" ></i></el-button>
            </el-tooltip>            
          </template>
        </el-table-column>
      </el-table>
      <div style="padding:10px" ref="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 30, 50, 70, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next"
          :total="totalViolations"
          >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import qs from 'qs'
  export default {
    data () {
      return {
        violations: [],
        incident: {incident_type: null, bus: {}, monitor: {}},
        loading: true,
        status: {0: 'success', 1: 'warning', 2: 'danger'},
        filter: null,
        active_filter: 'bus',
        buses: [],
        BusID: '',
        Label: '',
        date: [null, null],
        totalViolations: 0,
        currentPage: 1,
        visitedPage: [1],
        new_page: false,
        limit: 20,
        tableHeight: 0
      }
    },
    computed: {
      options () {
        let options = [{
          value: 'bus',
          label: this.$t('BUS')
        }, {
          value: 'type',
          label: this.$t('VIOLATIONTYPE')
        }, {
          value: 'date',
          label: this.$t('DATE')
        }]
        return options
      },
      violationTypes () {
        let violationTypes = {5: this.$t('SMOKEDETECTED'), 13: this.$t('PANICBUTTONPRESSED'), 15: this.$t('HIGHSPEEDALARM')}
        return violationTypes
      }
    },
    mounted () {
      this.switchLanguage()
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53)
      this.getViolations()
      this.getBuses()
    },
    methods: {
      getViolations (filter = false) {
        let self = this
        if (filter) {
          self.currentPage = 1
          self.visitedPage = [1]
          self.new_page = true
          self.violations = {}
        }
        if (self.violations[self.currentPage - 1] !== undefined) return
        this.$http.get('/violation?' + qs.stringify(self.bindCurrentFilters()) + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1)).then(function (response) {
          Vue.set(self.violations, self.currentPage - 1, response.data.violations)
          self.totalViolations = response.data.total
          self.new_page = self.loading = false
        }).catch(function (response) {})
      },
      bindCurrentFilters () {
        let data = {filters: []}
        if (_.isEmpty(this.active_filter)) return
        switch (this.active_filter) {
          case 'bus': data.filters['BusID'] = this.BusID
            break
          case 'type': data.filters['Label'] = this.Label
            break
          case 'date':
            if (_.isNull(this.date[0]) && _.isNull(this.date[1])) break
            data.filters['minDate'] = this.$moment(this.date[0]).format('YYYY-MM-DD')
            data.filters['maxDate'] = this.$moment(this.date[1]).format('YYYY-MM-DD')
            break
        }
        return data
      },
      handleSelect () {
        return true
      },
      handleRemove (file, fileList) {
        console.log(file, fileList)
      },
      handlePictureCardPreview (file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleSizeChange (val) {
        this.limit = val
        this.violations = {}
        this.currentPage = 1
        this.visitedPage = [1]
        this.loading = true
        this.getViolations()
      },
      handleCurrentChange (val) {
        this.currentPage = val
        if (this.visitedPage.indexOf(val) >= 0) return
        this.visitedPage.push(val)
        this.new_page = true
        this.getViolations()
      },
      changeFilter () {
        this.Label = this.BusID = ''
        if (this.filter === 'bus') this.getBuses()
      },
      getBuses () {
        let self = this
        if (!_.isEmpty(self.buses)) return
        this.$http.get('/bus')
          .then(function (response) {
            self.buses = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      removeFilter (filter) {
        this.changeFilter()
        this.filter = ''
        this.violations = {}
        this.getViolations()
      },
      changedFilter (val) {
        if (val === null) return
        this.active_filter = val
        this.filter = null
      },
      flagItem (item, type) {
        let flag = null
        if (type === 'sticky') {
          item.IsSticky = !item.IsSticky
          flag = item.IsSticky ? 1 : 0
        } else {
          item.IsHidden = !item.IsHidden
          flag = item.IsHidden ? 1 : 0
        }
        let postData = {id: item.ViolationID, type: type, flag: flag, name: 'violation'}
        this.$http.post('/report/flag', postData).then(function (response) {
        }).catch(function (response) {})
      }
    }
  }
</script>

<style>
  .googleMap{margin:-15px; margin-bottom:20px}
  .googleMap input{border-radius: 0; border-left:0; border-right:0}

</style>




// WEBPACK FOOTER //
// Violation.vue?f1074d0c